import React from 'react';

interface LogoProps {
  className?: string;
}

const QualityNexusLogo: React.FC<LogoProps> = ({ className = "w-12 h-12" }) => {
  return (
    <img
      src="/logo.png"
      alt="Quality Nexus Logo"
      className={className}
    />
  );
};

export default QualityNexusLogo;
